/**
 * Created by kairy on 19/10/18.
 */
export default (str) => {
  if (str) {
    let old = new RegExp('font-size:14.0pt;font-family:宋体;', 'g')
    let newstr = str.replace(old, '')
    // console.log(newstr)
    return newstr
  }
  return str
}



// WEBPACK FOOTER //
// ./src/filters/strreplace.js